import { Box, Text } from '@frameio/vapor';
import { CreateButton } from './CreateButton';
import TEXT from './generated/TEXT/Workspaces_Header';

export const Header = () => (
  <Box
    alignItems="center"
    display="flex"
    flexGrow="0"
    justifyContent="space-between"
    paddingBottom={TITLE_PADDING_BOTTOM}
    paddingLeft={TITLE_PADDING}
    paddingRight={TITLE_PADDING}
    paddingTop={TITLE_PADDING_TOP}
  >
    <Text color="tertiary" id="workspaceNavTitle" variant="secondary">
      {TEXT.header.title}
    </Text>
    <CreateButton />
  </Box>
);

TEXT.DEFINE({
  /** Text labels for the workspaces navigation header */
  header: {
    /** Header title for the workspaces section */
    title: 'Workspaces',
  },
});

const TITLE_PADDING = 16;
const TITLE_PADDING_TOP = 6;
const TITLE_PADDING_BOTTOM = 8;
